module.exports = __webpack_public_path__ + "static/media/no-coupons.8d6c0bfc.png";